import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMapModule } from 'src/app/modules/ngx-map/ngx-map.module';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { OutcomesComponent } from './outcomes.component';
import { OutcomesTableComponent } from './components/outcomes-table/outcomes-table.component';
import { OutcomesDetailsComponent } from './components/outcomes-details/outcomes-details.component';


@NgModule({
  declarations: [OutcomesComponent, OutcomesTableComponent, OutcomesDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      { path: 'review-outcomes', component: OutcomesComponent },
      { path: 'outcomes-status/:id', component: OutcomesDetailsComponent },
      { path: 'outcomes-details/:id', component: OutcomesDetailsComponent }
    ]),
    NgxMapModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class OutcomesModule { }
